import React from "react";
import { withTranslation } from "react-i18next";
import { Form, Typography } from "antd";
import { CustomInput } from "../customComponent/CustomInput";

const { Text } = Typography;

const TrackingNumberFormItemComponent = ({
  t,
  style,
  label,
  required = true,
  editable = true,
  showLabel = false,
  strong = false
}) => (
  <Form.Item
    name="trackingNumber"
    required={false}
    colon={false}
    label={showLabel ? <Text strong={strong}>{label ? label : t("form.tracking_number.label")}</Text> : null}
    rules={[
      { required: required, message: t("form.tracking_number.error_required") },
      {
        pattern: /^[A-Za-z\d]*$/,
        message: t("form.tracking_number.error_pattern")
      }
    ]}
    style={style}
  >
    <CustomInput disabled={!editable} placeholder={t("form.tracking_number.placeholder")} />
  </Form.Item>
);

const TrackingNumberFormItem = withTranslation()(TrackingNumberFormItemComponent);

export { TrackingNumberFormItem };
